import type { IWorkspace } from '../../types';
import { useUpdateBaseModel } from '../base';
import { currentUserQueryKey } from '../user/useCurrentUser';
import { workspaceQueryKeyFactory } from './constants';

export function useUpdateWorkspace(id: string) {
	return useUpdateBaseModel<IWorkspace>({
		queryKeyFactory: workspaceQueryKeyFactory,
		namespace: workspaceQueryKeyFactory.namespace,

		invalidationKeys: [
			// Invalidate the workspace by id, this applies to useListWorkspace.
			workspaceQueryKeyFactory.byId(id),
			// Invalidate 'this' workspace, this applies to useWorkspace.
			currentUserQueryKey,
		],
	});
}
